import { generatorUtils, GridDesign } from '@gelatoas/design-editor-calendar';

// grid-desk-0's grid (80.71 mm high on the 258 mm desk page, bleed included) is where every grid design was
// checked to fit a six-week month at full type size. Everything vertical in a grid scales with its type, so a shorter grid
// fits when its type shrinks by the same ratio.
const FULL_TYPE_GRID_HEIGHT_PER_SPREAD_WIDTH = 80.71 / 258;

/** Design-unit to grid-unit converter; `gridHeight` and `spreadWidth` must share a unit. */
function getGridToSizeFn(gridDesign: GridDesign, spreadWidth: number, gridHeight: number, fitToHeight?: true) {
  const d2f = generatorUtils.getToSizeFn(gridDesign, spreadWidth);
  if (!fitToHeight) {
    return d2f;
  }

  const scale = Math.min(1, gridHeight / (spreadWidth * FULL_TYPE_GRID_HEIGHT_PER_SPREAD_WIDTH));
  return (x: number) => d2f(x) * scale;
}

export default getGridToSizeFn;
